module.exports = __webpack_public_path__ + "img/pi-1-4.7780e5ff.jpg";